import { render } from "./App.vue?vue&type=template&id=691d2a6e"
const script = {}

import exportComponent from "/codebuild/output/src204121365/src/github.com/ustec/smart-phr.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__